/**
 * Shared formatting and scoring utilities for Oracle Insight.
 * Extracted from App.tsx to allow reuse across tab components.
 */

export const parseRadarScore = (value: string | undefined): number => {
  if (!value) return 1;
  const v = value.toLowerCase();
  
  // Strongest signals
  if (v.includes('wide') || v.includes('exceptional') || v.includes('excellent') || v.includes('massive') || v.includes('very high') || v.includes('extreme') || v.includes('elite') || v.includes('simple') || v.includes('highly stable')) return 5;
  
  // Medium-High (before High matches)
  if (v.includes('medium-high') || v.includes('medium high') || v.includes('strong')) return 4;
  
  // High / Solid
  if (v.includes('high') || v.includes('good') || v === 'yes' || v.includes('solid') || v.includes('adequate') || v.includes('understandable')) return 4;
  
  // Medium
  if (v.includes('medium') || v.includes('moderate') || v.includes('narrow') || v.includes('fair') || v.includes('some') || v.includes('average')) return 3;
  
  // Weak
  if (v.includes('low') || v.includes('poor') || v.includes('weak') || v.includes('limited') || v === 'no' || v.includes('none') || v.includes('erod') || v.includes('insufficient') || v.includes('cyclical') || v.includes('complex')) return 2;
  
  // Default (e.g., None, N/A)
  return 1;
};

export const formatNumber = (val: number | undefined | null, options?: Intl.NumberFormatOptions): string => {
  if (val === undefined || val === null || isNaN(val)) return 'N/A';
  return val.toLocaleString(undefined, options);
};

export const safeToFixed = (val: number | undefined | null, decimals: number = 2): string => {
  if (val === undefined || val === null || isNaN(val) || !isFinite(val)) return 'N/A';
  return val.toFixed(decimals);
};
